import { useMutation } from '@tanstack/react-query';

import { companyApi } from './api-handlers';
import { companyQueryKeys } from './query-keys';

import type { TCompany } from '../model';

export const useSetActiveCompanyMutation = () =>
    useMutation({
        mutationKey: companyQueryKeys.setActive(),
        mutationFn: (companyId: TCompany['id']) => companyApi.setActiveCompany(companyId),
    });
